const mEditionAcademyLegalsEmailSignature = {
  mEditionAcademyLegalsEmailSignature: {
    alerts: {
      updateAcademiaLegales: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos legales para Políticas de Privacidad fueron guardados exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      text: {
        label: 'Firma de Email'
      }
    }
  }
}

export default mEditionAcademyLegalsEmailSignature
